import "./footer.css";
import { Link } from "react-router-dom";
import stores from "./storeData";

export default function Footer() {

  const year = new Date().getFullYear();

  const location =

    localStorage.getItem("storeLocation")
    || "Apple 1";

  const store = stores[location];

  return (

    <footer className="footer">

      {/* TOP */}
      <div className="footer-top">

        <button
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          ↑ Back to Top
        </button>

      </div>

      {/* MAIN */}
      <div className="footer-main">

        {/* CONTACT */}
        <div className="footer-box">

          <h4>Contact Us</h4>

          <p>
            📍 {store.address}
          </p>

          <a href={`tel:${store.phone}`}>
            📞 {store.phone}
          </a>

          <a href={`mailto:${store.email}`}>
            ✉ {store.email}
          </a>

        </div>

        {/* ABOUT */}
        <div className="footer-box">

          <h4>About</h4>

          <Link to="/about">
            About Us
          </Link>

          <Link to="/">
            Shop
          </Link>

          <Link to="/faqs">
            FAQs
          </Link>

          <Link to="/contact">
            Contact Us
          </Link>

        </div>

        {/* SHOP */}
        <div className="footer-box">

          <h4>Shop Categories</h4>

          <Link to="/?category=Grinders">
            → Shop Grinders
          </Link>

          <Link to="/?category=Pre-Rolls">
            → Shop Pre-Rolls
          </Link>

          <Link to="/?category=Vapes">
            → Shop Vapes
          </Link>

          <Link to="/?category=Accessories">
            → Shop Accessories
          </Link>

        </div>

        {/* SOCIAL */}
        <div className="footer-box">

          <h4>Follow Us</h4>

          <div className="social-links">

            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
            >
              Instagram
            </a>

            <a
              href="https://www.facebook.com/61559605953131/"
              target="_blank"
              rel="noreferrer"
            >
              Facebook
            </a>

          </div>

        </div>

        {/* NEWSLETTER */}
        <div className="footer-box newsletter-box">

          <h4>
            {store.name} Newsletter
          </h4>

          <p>
            Join our family and receive
            special promotions and smoke
            shop updates.
          </p>

          <form
            onSubmit={(e) => {

              e.preventDefault();

              alert(
                "🎉 Thank you for joining!"
              );
            }}
          >

            <input
              type="email"
              placeholder="Enter your email"
              required
            />

            <button type="submit">
              JOIN US
            </button>

          </form>

        </div>

      </div>

      {/* DISCLAIMER */}
      <div className="footer-disclaimer">

        Disclaimer: These products are not
        intended to diagnose, treat,
        cure, or prevent any disease.
        Products are intended for adults
        21+ only. Please use responsibly.

      </div>

      {/* FOOTER LINKS */}
      <div className="footer-links">

        <Link to="/privacy">
          Privacy Policy
        </Link>

        <Link to="/terms">
          Terms & Conditions
        </Link>

        <Link to="/shipping">
          Shipping Policy
        </Link>

        <Link to="/returns">
          Return Policy
        </Link>

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">

        © {year} {store.name}.
        All Rights Reserved.

      </div>

    </footer>
  );
}